<template>
  <div class="check-box-group">
    <div v-for="item in options" :key="item.id" @click="handleTrriger(item)" class="check-box-item" :class="{isCheck: checkStatus(item)}">
      <div>{{item.goodsTypeName}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => [
        { id: 1, goodsTypeName: '普货' },
        { id: 2, goodsTypeName: '服装类' },
        { id: 3, goodsTypeName: '家具类' },
        { id: 4, goodsTypeName: '化妆品类' },
        { id: 5, goodsTypeName: '食品类' },
        { id: 6, goodsTypeName: '3C类' },
        { id: 7, goodsTypeName: '敏货类' },
        { id: 8, goodsTypeName: '其他' }
      ]
    }
  },
  data() {
    return {
      selectValue: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selectValue = val
      }
    }
  },
  methods: {
    checkStatus(val) {
      const ids = this.selectValue.map(v => v.id)
      return ids.includes(val.id)
    },
    handleTrriger(val) {
      let list = []
      // if (this.selectValue.find(el => el.id === val.id)) {
      //   list = this.selectValue.filter(v => v.id !== val.id)
      // } else {
      //   list = [...this.selectValue, val]
      // }
      list = [val]
      const ids = list.map(v => v.id)
      list = this.options.filter(v => {
        return ids.includes(v.id)
      })
      this.$emit('input', list)
      this.$emit('change', list)
    }
  }
}
</script>

<style lang="scss" scoped>
  .check-box-group {
    display: flex;
  }
  .check-box-item {
    margin-right: 10px;
    padding: 0 15px;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    font-weight: normal;
    color: #141414;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background: rgba(255,77,1,0.1);
    }
    &.isCheck {
      color: #FFFFFF;
      background: #FF4D01;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/inquiryQueryBar/checkGroup.vue